import { $, $$ } from '../../../shared/js/utils/dom';
import { Swiper } from 'swiper';

const quizSliders = $$('.slider--quiz');

class QuizSlider {
  constructor(params) {
    this.container = params.container;
    this.navButtons = $$('[data-slide-to]', this.container);
    this.activeSlide = null;
  }

  initQuizSlider = () => {
    this.sliderInstance = new Swiper(this.container, {
      slidesPerView: 1,
      loop: false,
      navigation: false,
      init: false,
      autoHeight: true,
    });

    this.sliderInstance.on('afterInit', () => {
      this.bindNavButtonClick();
      this.preventTabSlideChange();
    });

    // Slide change event to focus the first element in the active slide
    this.sliderInstance.on('slideChangeTransitionEnd', () => {
      this.activeSlide =
        this.sliderInstance.slides[this.sliderInstance.activeIndex];
      // const heading = $('h3[tabindex]', this.activeSlide);
      // heading.focus();
      const focusAnchor = $('.quiz__focus-anchor', this.activeSlide);
      focusAnchor.focus();
    });

    this.sliderInstance.init();
  };

  bindNavButtonClick = () => {
    this.navButtons.forEach(button => {
      button.addEventListener('click', () => {
        const slideId = button.getAttribute('data-slide-to');
        this.sliderInstance.slideTo(slideId, 500);
      });
    });
  };

  preventTabSlideChange = () => {
    this.container.addEventListener('keydown', e => {
      if (e.key === 'Tab') {
        this.activeSlide =
          this.sliderInstance.slides[this.sliderInstance.activeIndex];

        const focusableElements = this.activeSlide.querySelectorAll(
          'button, a[href], [tabindex]'
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          // Shift + Tab (Backward navigation)
          if (document.activeElement === firstFocusable) {
            lastFocusable.focus();
            e.preventDefault();
          }
        } else {
          // Tab (Forward navigation)
          if (document.activeElement === lastFocusable) {
            firstFocusable.focus();
            e.preventDefault();
          }
        }
      }
    });
  };
}

if (quizSliders.length) {
  quizSliders.forEach(slider => {
    new QuizSlider({
      container: slider,
    }).initQuizSlider();
  });
}
